<div class="min-h-screen overflow-x-hidden bg-slate-50 font-inter text-slate-950">
  <header
    class="fixed inset-x-0 top-0 z-50 border-b border-slate-200/70 bg-white/90 backdrop-blur-xl">
    <div
      class="mx-auto flex max-w-page items-center justify-between gap-4 px-4 py-3.5 sm:px-6 lg:px-8">
      <div class="flex min-w-0 items-center gap-5 sm:gap-8">
        <a routerLink="/" class="flex min-w-0 cursor-pointer items-center gap-3">
          <img
            src="assets/brand/logo.svg"
            width="36"
            height="36"
            alt="FormOps logo"
            class="h-9 w-9 shrink-0" />
          <p class="text-sm font-semibold text-slate-950">FormOps</p>
        </a>

        @if (isAuthenticated()) {
          <a
            routerLink="/my-forms/inbox"
            routerLinkActive="bg-slate-100 text-slate-950"
            class="cursor-pointer rounded-lg px-2.5 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-100 hover:text-slate-950">
            My list
          </a>
        }
      </div>

      @if (isAuthenticated()) {
        <app-respondent-account-menu-button />
      }
    </div>
  </header>

  <div class="pt-[4.25rem]">
    <router-outlet />
  </div>
</div>
